import { useMemo, useState } from "react";

import { useAppState } from "contextApi/appContext";
import { CalendarActivity, isContentFactoryActivity } from "./activityUtils";

export function useCreatePostsFilter(activities?: CalendarActivity[]) {
  const showContentFactoryTab = useAppState(
    state => state.showContentFactoryTab
  );
  const [isCreatePostsVisible, setIsCreatePostsVisible] = useState(true);

  const visibleActivities = useMemo(
    () =>
      isCreatePostsVisible
        ? activities
        : activities?.filter(activity => !isContentFactoryActivity(activity)),
    [activities, isCreatePostsVisible]
  );

  const createPostsFilter = showContentFactoryTab
    ? { isVisible: isCreatePostsVisible, onSave: setIsCreatePostsVisible }
    : null;

  return { visibleActivities, createPostsFilter };
}
